"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("@material-ui/core/styles");

var _FieldsOverlay = _interopRequireDefault(require("./FieldsOverlay"));

var _ActionBar = _interopRequireDefault(require("./ActionBar"));

var _DocumentImage = _interopRequireDefault(require("./DocumentImage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var styles = {
  root: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    display: 'grid',
    gridTemplateRows: 'minMax(60px, 6.5%) 1fr',
    gridTemplateColumns: '100%',
    gridTemplateAreas: "\n    \"actionBar\"\n    \"imageOverlay\""
  },
  actionBar: {
    gridArea: 'actionBar'
  },
  contentContainer: {
    zIndex: 2,
    overflow: 'auto',
    background: '#eef3f6'
  },
  withSidebar: {
    display: 'grid',
    gridTemplateAreas: "\n      \"document sidebar\"\n    ",
    gridTemplateColumns: '70% 30%',
    gridTemplateRows: '100%'
  },
  documentImageContainer: {
    gridArea: 'document',
    overflow: 'auto',
    height: '100%',
    width: '100%'
  }
};

var DocumentViewer = /*#__PURE__*/function (_Component) {
  _inherits(DocumentViewer, _Component);

  function DocumentViewer() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, DocumentViewer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(DocumentViewer)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      zoom: 1,
      page: 1,
      isLoading: true
    });

    _defineProperty(_assertThisInitialized(_this), "setZoom", function (increment) {
      _this.setState(function (_ref) {
        var zoom = _ref.zoom;
        return {
          zoom: zoom + increment
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getZoom", function () {
      // Calculate the zoom for the document which will have the document
      // at full width for the container
      var _this$props = _this.props,
          currentDocument = _this$props.currentDocument,
          withSidebar = _this$props.withSidebar;
      if (!currentDocument) return 1;
      var width = currentDocument.width;
      var containerWidth;

      if (withSidebar) {
        var clientWidth = _this.__imageContainer.clientWidth;
        containerWidth = clientWidth;
      } else {
        var _clientWidth = _this.__docContainer.clientWidth;
        containerWidth = _clientWidth;
      }

      return containerWidth / width;
    });

    _defineProperty(_assertThisInitialized(_this), "resetZoom", function () {
      return new Promise(function (resolve) {
        _this.setState(function () {
          return {
            zoom: _this.getZoom()
          };
        }, resolve);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setPage", function (increment, newPage) {
      return new Promise(function (resolve) {
        _this.setState(function (_ref2) {
          var page = _ref2.page;

          if (newPage === page) {
            resolve();
            return;
          }

          return {
            isLoading: true,
            page: newPage || page + increment
          };
        }, function () {
          _this.resetZoom().then(function () {
            return setTimeout(resolve);
          });
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentImageLoaded", function () {
      _this.scrollTo(0);

      _this.setState({
        isLoading: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "scrollTo", function (top) {
      return _this.__imageContainer.scrollTop = top;
    });

    _defineProperty(_assertThisInitialized(_this), "setDocContainerRef", function (ref) {
      // Capture the dom ref so we can use it for scrolling
      _this.__docContainer = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "setImageContainerRef", function (ref) {
      // Capture the dom ref for the image container to adjust the
      // zoom variable and width based on withSidebar prop
      _this.__imageContainer = ref;
    });

    _defineProperty(_assertThisInitialized(_this), "onNewDoc", function () {
      _this.setState({
        isLoading: true
      });

      _this.setPage(null, 1);
    });

    return _this;
  }

  _createClass(DocumentViewer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onNewDoc();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var currId = this.props.currentDocument.id;
      var nextId = nextProps.currentDocument.id;
      if (currId !== nextId) this.onNewDoc();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          isLoading = _this$state.isLoading,
          page = _this$state.page,
          zoom = _this$state.zoom;
      var _this$props2 = this.props,
          classes = _this$props2.classes,
          currentDocument = _this$props2.currentDocument,
          getDocumentImageUrls = _this$props2.getDocumentImageUrls,
          setCurrentDocument = _this$props2.setCurrentDocument,
          actionButtons = _this$props2.actionButtons,
          prevDocId = _this$props2.prevDocId,
          nextDocId = _this$props2.nextDocId,
          renderField = _this$props2.renderField,
          throwFatalError = _this$props2.throwFatalError,
          _this$props2$activeRo = _this$props2.activeRoleId,
          activeRoleId = _this$props2$activeRo === void 0 ? null : _this$props2$activeRo,
          _this$props2$activeRu = _this$props2.activeRuleGroupId,
          activeRuleGroupId = _this$props2$activeRu === void 0 ? null : _this$props2$activeRu,
          className = _this$props2.className,
          _this$props2$actionBa = _this$props2.actionBarProps,
          actionBarProps = _this$props2$actionBa === void 0 ? {} : _this$props2$actionBa,
          _this$props2$withSide = _this$props2.withSidebar,
          withSidebar = _this$props2$withSide === void 0 ? false : _this$props2$withSide,
          sideBar = _this$props2.sideBar;

      var _ref3 = actionBarProps || {},
          additionalActionButtons = _ref3.actionButtons;

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.root, className)
      }, _react.default.createElement(_ActionBar.default, _extends({}, actionBarProps, {
        setPage: this.setPage,
        setZoom: this.setZoom,
        resetZoom: this.resetZoom,
        page: page,
        pageCount: currentDocument.pages,
        setCurrentDocument: setCurrentDocument,
        prevDocId: prevDocId,
        nextDocId: nextDocId,
        actionButtons: actionButtons || additionalActionButtons,
        withSidebar: withSidebar
      })), _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.contentContainer, _defineProperty({}, classes.withSidebar, withSidebar)),
        ref: this.setDocContainerRef
      }, _react.default.createElement("div", {
        className: classes.documentImageContainer,
        ref: this.setImageContainerRef
      }, _react.default.createElement(_DocumentImage.default, {
        doc: currentDocument,
        page: page,
        zoom: zoom,
        getDocumentImageUrls: getDocumentImageUrls,
        throwFatalError: throwFatalError,
        onLoad: this.onCurrentImageLoaded
      }), !isLoading && _react.default.createElement(_FieldsOverlay.default, {
        currentDocument: currentDocument,
        page: page,
        zoom: zoom,
        renderField: renderField,
        activeRoleId: activeRoleId,
        activeRuleGroupId: activeRuleGroupId
      })), sideBar));
    }
  }]);

  return DocumentViewer;
}(_react.Component);

var _default = (0, _styles.withStyles)(styles)(DocumentViewer);

exports.default = _default;